import type { RecordingEntrySurface } from '@heidi/plugin-rpa';

export const RECORDER_ENTRY_SURFACE = {
  OVERLAY: 'overlay',
  DESKTOP_APP: 'desktopApp',
} as const satisfies Record<string, RecordingEntrySurface>;
